import { styled } from "@mui/material";

export const LoginContainer = styled("div")`
  background-color: ${({ theme }) => theme.palette.background.default};
`;
